<template>
  <div
    class="container float-container"
    v-bind:class="{ active: value || focused }"
  >
    <div v-if="showDropdown" class="autoselect-domains">
      <div
        v-for="(option, index) in filteredDomains"
        v-bind:key="option"
        v-bind:class="{ active: selectedIndex == index }"
        @click="selectOption(index)"
      >
        <span :title="option" :data-obfuscate="quantumObfuscate">{{
          option
        }}</span>
      </div>
    </div>
    <label :for="'email-' + _uid" :class="{ error: error }">Email</label>
    <input
      :id="'email-' + _uid"
      type="search"
      :class="{ error: error }"
      :value="value"
      :data-obfuscate="quantumObfuscate"
      @keydown="onKeyDown"
      @input="onInput"
      @blur="onBlur"
      @focus="onFocus"
      @click="$emit('click')"
    />
    <span class="error" v-if="error">
      <img src="@/assets/img/1x/error_icon.png" alt="Ícono error" />
      <p>{{ error }}</p>
    </span>
  </div>
</template>

<script>
export default {
  name: "EmailField",
  props: {
    value: String,
    name: String,
    required: {
      type: Boolean,
      default: false
    },
    analyticsName: {
      type: String,
      default: null
    },
    analyticsTypology: {
      type: String,
      default: null
    },
    quantumObfuscate: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      checked: false,
      focused: false,
      showDropdown: false,
      selectedIndex: 0,
      domains: [
        "gmail.com",
        "hotmail.com",
        "yahoo.com",
        "arnet.com.ar",
        "facebook.com",
        "googlemail.com",
        "google.com",
        "hotmail.com.ar",
        "live.com",
        "mail.com",
        "msn.com",
        "outlook.com",
        "yahoo.com.ar"
      ]
    };
  },
  mounted() {
    this.subscribe(this);
  },
  computed: {
    error() {
      if (this.checked) {
        if (this.isVoid()) {
          return "Tenés que ingresar este dato";
        } else if (!this.isValid()) {
          return "El email ingresado es incorrecto";
        }
      }
      return null;
    },
    filteredDomains() {
      let inputValue =
        this.value && this.value !== "undefined"
          ? (this.value + "").trim()
          : "";
      let emailsDirty = inputValue.split("@");
      if (emailsDirty.length < 2 || emailsDirty[0] == "") {
        return [];
      }
      let emailUser = emailsDirty[0];
      let emailDomain = emailsDirty[1];

      return this.domains.reduce((filtered, domain) => {
        // Máximo de 3 items
        if (filtered.length >= 3) {
          return filtered;
        }

        // Filtrar
        // Si el emailDomain que ingresó el usuario está en blanco (lo que sucede apenas se escribe "@")
        // entonces devuelve los 3 primeros items del array (que deberían ser los más populares)
        if (domain.toLowerCase().indexOf(emailDomain.toLowerCase()) !== -1) {
          // Agregar el valor antes
          filtered.push(emailUser + "@" + domain);
        }
        return filtered;
      }, []);
    }
  },
  methods: {
    checkValid() {
      this.checked = true;
      return this.isValid();
    },
    isVoid() {
      return this.value == null || this.value.trim() === "";
    },
    isValid() {
      if (this.required) {
        const emailRegex = /^([A-Za-z0-9_\-.])+@([A-Za-z0-9_\-.])+\.([A-Za-z]{2,4})$/;
        return emailRegex.test(this.value.trim());
      }
      return true;
    },
    onInput(e) {
      this.$emit("input", e.target.value.trim());
    },
    onKeyDown(e) {
      // Mostrar dropdown si se escribe un @
      this.showDropdown =
        e.key === "@" || (this.value && this.value.indexOf("@") !== -1);

      if (e.key === " ") {
        // Si entramos un espacio no lo permitimos
        e.preventDefault();
      }

      if (e.key === "ArrowDown") {
        // Movemos el índice
        this.selectedIndex += 1;
        e.preventDefault();
      }

      if (e.key === "ArrowUp") {
        // Movemos el índice
        this.selectedIndex -= 1;
        e.preventDefault();
      }

      // Corregir límites
      if (this.selectedIndex >= this.filteredDomains.length) {
        this.selectedIndex = this.filteredDomains.length - 1;
      } else if (this.selectedIndex <= 0) {
        this.selectedIndex = 0;
      }

      // Al hacer enter
      if (e.key === "Enter") {
        this.selectOption(this.selectedIndex);
      }
    },
    onBlur() {
      this.focused = false;
      setTimeout(() => {
        this.showDropdown = false;
      }, 150);
    },
    onFocus() {
      this.$emit("onFocus");
      this.focused = true;
      /* Animar viewport para que el elemento quede arriba
      70 = alto de topbar + padding */
      let offsetTop = this.$el.getBoundingClientRect().top + window.scrollY;
      window.scroll({
        top: offsetTop - 70,
        left: 0,
        behavior: "smooth"
      });
    },
    selectOption(index) {
      let inputValue =
        this.value && this.value !== "undefined"
          ? (this.value + "").trim()
          : "";
      let emailsDirty = inputValue.split("@");
      if (emailsDirty.length < 2 || emailsDirty[0] == "") {
        return false;
      }

      if (this.filteredDomains[index] && this.filteredDomains[index] !== -1) {
        this.$emit("input", this.filteredDomains[index]);
        this.showDropdown = false;
      }
    }
  }
};
</script>

<style scoped>
input {
  /* Dar un poco de espacio para "centrar" el texto verticalmente */
  border-top: 17px solid transparent;
}

div.float-container {
  position: relative;
}

label {
  font-size: 15px;
  color: #666;
  font-family: "BentonSansBBVA-Book", Helvetica, Arial, sans-serif;
  position: absolute;
  -webkit-transform-origin: top left;
  transform-origin: top left;
  -webkit-transform: translate(16px, 19px) scale(1);
  transform: translate(16px, 19px) scale(1);
  transition: all 0.3s ease-in-out;
}
div.float-container.active label {
  -webkit-transform: translate(16px, 8px) scale(0.75);
  transform: translate(16px, 8px) scale(0.75);
}

/* Estilos para errores */

label.error {
  color: #b92a45;
}

input.error {
  background: #fcdfdf;
}

span.error {
  margin-left: 16px;
  margin-top: 8px;
  display: block;
}

span > img,
span > p {
  display: inline-block;
  vertical-align: top;
}

span > img {
  width: 16px;
}

span > p {
  margin-left: 2px;
  margin-top: 0px;
  margin-bottom: 0px;
  font-family: "BentonSansBBVA-Light", Helvetica, Arial, sans-serif;
  font-size: 12px;
  line-height: 1.33;
  color: #121212;
}

/* Estilos Autocompletado */

.autoselect-domains {
  position: absolute;
  z-index: 100;
  left: 0;
  right: 0;
  top: 56px; /* Alto inputs */
  background: white;
  max-height: 250px;
  overflow-x: hidden;
  overflow-y: auto;
  box-shadow: 0 0 5px 0px rgba(0, 0, 0, 0.2);
}

.autoselect-domains span {
  display: block;
  overflow: hidden;
  text-overflow: ellipsis;
  padding: 16px 0;
  border-bottom: 1px solid #bdbdbd;
  font-family: "BentonSansBBVA-Light", Helvetica, Arial, sans-serif;
  cursor: pointer;
}

.autoselect-domains div {
  padding: 0 16px;
}

.autoselect-domains div.active,
.autoselect-domains div:hover {
  background-color: #eeeeee;
}

.autoselect-domains div:last-child span {
  border-bottom: 0;
}

.autoselect-domains span:hover {
  color: #000;
}
</style>
